// extracted by mini-css-extract-plugin
export var scoreBoardContainer = "ScoreBoard-module--scoreBoardContainer--2Yqwy";
export var scoreBoardTitle = "ScoreBoard-module--scoreBoardTitle--34thG";
export var scoreBoard = "ScoreBoard-module--scoreBoard--2_5kY";
export var inactive = "ScoreBoard-module--inactive--2vAIb";